import React from 'react';
import MainMenuComponent from '../../Components/Menus/MainMenuComponent';

function ManagementToolsPage() {
  return <MainMenuComponent menuName="tools" />;
}

export default ManagementToolsPage;
